import { useMemo } from 'react';
import { Plan } from 'commons/services/configurationService';

export const useAvailableInstallments = (
  plans: Plan[] | undefined,
  tiendanubePlan: string,
): number[] =>
  useMemo(() => {
    if (!plans || !tiendanubePlan) return [];

    const selectedPlan = plans.find(
      (plan: Plan) => plan.externalId === tiendanubePlan,
    );
    if (!selectedPlan) return [];

    const creditCardAnticipation = selectedPlan.anticipations?.find(
      (a: { paymentMethod: string }) => a.paymentMethod === 'credit_card',
    );
    if (!creditCardAnticipation) return [];

    return creditCardAnticipation.installments
      .filter(
        (inst: { installmentNumber: number }) => inst.installmentNumber > 1,
      )
      .map((inst: { installmentNumber: number }) => inst.installmentNumber);
  }, [plans, tiendanubePlan]);
